module.exports = __webpack_public_path__ + "static/media/ibd_shoulder1.9d064bf9.png";